import { InjectionToken } from '@angular/core';
export const ModelsUrl = new InjectionToken<string>(
  'ngx-face-api-js.models-url',
);
